export enum EventTimePreference {
  Real = 1,
  Simulation = 2,
}
